import React from 'react'
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap.bundle"
import './css/footerdemocss.css'

export default function Footerdemo() {
  return (
    <div className="main-section">
    {/* newsletter */}
    <section className="newsletter-section">
      <div className="newsletter-container">
        <h2 className="newsletter-title">Sign Up for the EI Newsletter</h2>
        <p className="newsletter-description">
          Get the latest business news, informative insight, business strategies, technological hacks
          , culture reviews, innovations, and videos directly in your inbox.
        </p>
        <form className="newsletter-form">
        
          <input name='for'
            type="email"
            placeholder="Enter your email"
            className="newsletter-email-input"
          />
          <button type="submit" className="newsletter-submit-button">
            Sign Up
          </button>
        </form>
      </div>
    </section>
    {/* footer */}
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* More from Vogue */}
          <div>
            <h3>More from TSD</h3>
            <ul>
              <li>Newsletter Sign Up</li>
              <li>EI Club</li>
              <li>Careers</li>
              <li>Our Team</li>
            </ul>
          </div>
          {/* Connect */}
          <div>
            <h3>Connect</h3>
            <ul>
              <li>Facebook</li>
              <li>Twitter</li>
              <li>Instagram</li>
              <li>Linkedin</li>
            </ul>
          </div>
          {/* About */}
          <div>
            <h3>About</h3>
            <ul>
              <li>About TSD</li>
              <li>Media Kit</li>
              <li>Contact</li>
              <li>Careers</li>
            </ul>
          </div>
          {/* Press */}
          <div>
            <h3>Press</h3>
            <ul>
              <li>Press Room</li>
              <li>Contact Us</li>
              <li>Advertising</li>
              <li>Subscriptions</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© Copyright 2025, Entrepreneur Insights Media | All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  </div>

  )
}
